import {isNil} from 'ramda';

import {Nullish} from 'shared/web';

import {DefaultFoundationTheme, ThemeShadowsPath} from './foundationTheme';
import {getThemeValue} from './getThemeValue';

export function getShadowByPath(
  shadow: ThemeShadowsPath | Nullish,
  theme: DefaultFoundationTheme
): string | undefined {
  if (isNil(shadow)) {
    return undefined;
  }

  return getThemeValue<string>(theme.shadows, shadow);
}
